import { getImageFromS3 } from '../../../imageService';

export const challengeComponent = [
  {
    id: 'divide-your-routine',
    title: 'Розбав свою рутину',
    description:
      'Рутино, тримайся: ми прийшли\n' +
      'по тебе.\n' +
      'Пройди квіз та отримай чекліст \n' +
      'з ідеями, які освіжать буденність.',
    backgroundImage: getImageFromS3(
      '/images/taste-experimenter-challenge/bg.png'
    ),
    welcomeBackgroundIcon: getImageFromS3(
      '/images/taste-experimenter-challenge/welcome-background-icon.png'
    ),
    startButtonTitle: 'Поїхали!',
    questions: [
      {
        id: 1,
        title: 'Твоя роль у компанії друзів:',
        answerList: [
          { id: 1.1, title: 'Лідер, який усіх збирає' },
          { id: 1.2, title: 'Реготун, готовий на авантюри' },
          { id: 1.3, title: 'Голос розуму та розсудливості' }
        ]
      },
      {
        id: 2,
        title: 'Ти потрапляєш на вечірку, де нікого не знаєш. Твої дії?',
        answerList: [
          { id: 2.1, title: 'Потроху з усіма познайомлюсь' },
          { id: 2.2, title: 'Знайду когось такого ж «новенького»' },
          { id: 2.3, title: 'Чекатиму, поки хтось сам проявить ініціативу' }
        ]
      },
      {
        id: 3,
        title:
          'Як найкраще зафіксувати день у пам’яті?',
        answerList: [
          { id: 3.1, title: 'Зробити фото' },
          { id: 3.2, title: 'Забрати додому сувенір' },
          { id: 3.3, title: 'Бути в моменті та запам’ятовувати деталі' }
        ]
      },
      {
        id: 4,
        title:
          'Атрибут класного вихідного — це…',
        answerList: [
          { id: 4.1, title: 'Дегустація чогось нового' },
          { id: 4.2, title: 'Активність на свіжому повітрі' },
          { id: 4.3, title: 'Час наодинці' }
        ]
      },
      {
        id: 5,
        title:
          'Як ти ухвалюєш рішення?',
        answerList: [
          { id: 5.1, title: 'Миттєво, інтуїтивно' },
          { id: 5.2, title: 'Через експерименти — пробую та обираю' },
          { id: 5.3, title: 'Довго обдумую всі варіанти' }
        ]
      }
    ],
    resultList: [
      {
        id: 1,
        title: 'Ти — енергія, рух та імпульс.\n' +
          'Лови такий же активний чекліст, як і ти сам.',
        description:
          '1. Знайди новий маршрут у твоєму місті або здійсни мініподорож до сусіднього.\n\n' +
          '2. Протягом дня фотографуй усе червоного кольору. Це загострює увагу і навчає бачити деталі.\n\n' +
          '3. Спробуй страву, якої ніколи не куштував: в’єтнамський фо бо, грецька мусака чи щось ще сміливіше. Новий смак — новий досвід.',
        image: getImageFromS3(
          '/images/divide-your-routine-challenge/result1.png'
        )
      },
      {
        id: 2,
        title: 'Тобі важлива атмосфера та відчуття легкої імпровізації.\n' +
          'Що ж — лови свій чекліст.',
        description:
          '1. Відкрий сайт будь-якого кінотеатру, театру чи артцентру і наосліп тицьни у будь-яку активність. Це і буде сьогоднішнє відкриття.\n\n' +
          '2. Фотографуй предмети блакитного кольору. Увечері зможеш зібрати неочікувано стильний колаж.\n\n' +
          '3. Влаштуй з друзями мінівечірку. Не забудь взяти попкорн і поділитись враженнями про день.',
        image: getImageFromS3(
          '/images/divide-your-routine-challenge/result2.png'
        )
      },
      {
        id: 3,
        title: 'Ти — про сенси та внутрішній баланс. \n' +
          'Ось чекліст саме для тебе!',
        description:
          '1. Спробуй новий ритуал вдома: зроби маску, спробуй новий чай або ж приготуй щось цікаве.\n\n' +
          '2. Пройдися містом і увімкни музику, яку зазвичай не слухаєш. Любиш поп? Вмикай рок. Дозволь собі інше звучання дня та нові відчуття.\n\n' +
          '3. Фотографуй тільки прямокутні форми. Двері, вікна, етикетки, упаковки. Це медитативно й дуже естетично у фінальному колажі.',
        image: getImageFromS3(
          '/images/divide-your-routine-challenge/result3.png'
        )
      }
    ],
    afterResultContent: {
      title: 'Ну як тобі ідеї?',
      description: 'Залишайся з нами — попереду ще багато цікавого.',
      image: getImageFromS3(
        '/images/divide-your-routine-challenge/after-result-image.png'
      ),
      nextButtonText: 'Далі'
    }
  }
];
